"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScene = exports.createClock = exports.createCamera = exports.createRenderer = exports.createLights = exports.createOrbitControls = void 0;
var THREE = __importStar(require("three"));
var three_orbit_controls_1 = __importDefault(require("three-orbit-controls"));
/*
 * Allow the camera to orbit around a target
 */
var OrbitControls = (0, three_orbit_controls_1.default)(THREE);
/**
 * Creates orbit controller
 * @param domElement HTML canvas element
 */
var createOrbitControls = function (camera, domElement) {
    var orbit = new OrbitControls(camera, domElement);
    orbit.enableKeys = true;
    orbit.enableZoom = true;
    return orbit;
};
exports.createOrbitControls = createOrbitControls;
/**
 * Creates lights for the scene
 * @param color Lights color
 */
var createLights = function (color) {
    if (color === void 0) { color = 0xffffff; }
    var ambientLight = new THREE.AmbientLight(color);
    var lights = [];
    lights[0] = new THREE.PointLight(color, 1, 0);
    lights[1] = new THREE.PointLight(color, 1, 0);
    lights[2] = new THREE.PointLight(color, 1, 0);
    lights[0].position.set(0, 200, 0);
    lights[1].position.set(100, 200, 100);
    lights[2].position.set(-100, -200, -100);
    return [ambientLight, lights[0], lights[1], lights[2]];
};
exports.createLights = createLights;
/**
 * Creates webgl renderer
 * @param canvas The html canvas node
 */
var createRenderer = function (canvas) {
    var renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true,
        alpha: true
    });
    // Clear color
    renderer.setClearColor(0x0);
    // Clear alpha
    renderer.setClearAlpha(0);
    // Pixel ration setting
    renderer.setPixelRatio(window.devicePixelRatio);
    // Size setting
    renderer.setSize(window.innerWidth, window.innerHeight);
    return renderer;
};
exports.createRenderer = createRenderer;
/**
 * Creates camera object
 * @param initDistance Initial distance from center
 */
var createCamera = function (initDistance) {
    if (initDistance === void 0) { initDistance = 80; }
    var camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.z = initDistance;
    return camera;
};
exports.createCamera = createCamera;
/**
 * Creates a clock object
 */
var createClock = function () { return new THREE.Clock(); };
exports.createClock = createClock;
/**
 * Creates a scene object
 */
var createScene = function () { return new THREE.Scene(); };
exports.createScene = createScene;
